import { Money, Property } from './index';

export class ShowcaseProperty {
  id: number;
  message: string;
  status: string;
  property: Property;
  showcase_promo_price: Money;
}
